import React from "react";
import { FaEnvelope, FaLinkedin, FaInstagram } from "react-icons/fa";

const ContactSection: React.FC = () => {
    return (
        <section id="contact" className="py-16 px-6 bg-pastel-pink text-center">
            <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl font-display font-bold text-gray-800 mb-6">
                    Get in touch
                </h2>
                <p className="text-gray-700 mb-8">
                    Interested in collaborating or just want to say hi? Feel free to reach out on any of these platforms.
                </p>
                <div className="flex justify-center gap-6 text-3xl text-brand-primary">
                    <a
                        href="mailto:aishwaryarao514@gmail.com"
                        aria-label="Email"
                        className="hover:text-brand-secondary transition-colors"
                    >
                        <FaEnvelope />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/aishwaryarao7/"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="LinkedIn"
                        className="hover:text-brand-secondary transition-colors"
                    >
                        <FaLinkedin />
                    </a>
                    <a
                        href="https://www.instagram.com/aishwaryaarao/"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Instagram"
                        className="hover:text-brand-secondary transition-colors"
                    >
                        <FaInstagram />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default ContactSection; 